import React, { useEffect, useMemo, useState } from "react";
import { protocol } from '@remix/websocket-protocols';
import { useParams } from "react-router-dom";
import tournamentProvider, { ITournament, TournamentStatus } from "../../../providers/tournaments/tournaments.provider";
import Loader from "../../../components/loader";
import SocketConnection from "../../../providers/tournaments/tournament.socket.provider";
import authProvider from "../../../providers/auth.provider";
import TournamentHostEliminationsView from "./sub-views/host-eliminations.view";
import TournamentHostBracketView from "./sub-views/host-bracket.view";
import appProvider from "../../../providers/app.provider";
import TournamentFinalisedView from "./sub-views/finalised.view";

const TournamentHostViewPage = () => {
  let { id } = useParams<"id">();
  const [ tournament, setTournamentData ] = useState<ITournament | null>(null);

  const ws = useMemo(() => {
    const ws = new SocketConnection();

    authProvider.fetchWsToken()
      .then(async (token) => {
        if (token !== null) {
          await ws.start(authProvider.user!.id, token);

          ws.registerHandler(protocol.S2C_Tournament_Refresh, (message) => {
            if (message.tournamentId !== id) {
              return;
            }

            tournamentProvider.fetchTournament(id as string)
              .then((data) => {
                setTournamentData(data);
              });
          });
        }
      });

    return ws;
  }, [id])

  useEffect(() => {
    appProvider.setTitle('Tournaments / Host / ..');

    tournamentProvider.fetchTournament(id as string)
      .then((data) => {
        setTournamentData(data);
        appProvider.setTitle(`Tournaments / Host / ${data.name}`);
      });
  }, [id]);

  if (!id || tournament === null) {
    return <Loader />;
  }
  
  return (
    <div className="relative">
      {[TournamentStatus.STARTED, TournamentStatus.ELIMS_CLOSED].includes(tournament.status) &&
          <TournamentHostEliminationsView ws={ws} tournament={tournament} />
      }
      {tournament.status === TournamentStatus.BRACKETS_READY &&
          <TournamentHostBracketView ws={ws} tournament={tournament} />
      }
      {[TournamentStatus.FINISHED, TournamentStatus.ARCHIVED].includes(tournament.status) &&
          <TournamentFinalisedView tournament={tournament} />
      }
    </div>
  );
}

export default TournamentHostViewPage;